import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { MediaInProgressLoader } from './MediaInProgressLoader';

interface MediaSkeletonLoaderOverlayProps {
  /** Export progress percent while the media asset is being generated. */
  progressPercent?: number;
  /** Replaces the default in-progress loader when provided (e.g. stalled regeneration UI). */
  children?: ReactNode;
}

/** Centers the in-progress loader over a relative-positioned media skeleton. */
export function MediaSkeletonLoaderOverlay({
  progressPercent,
  children,
}: MediaSkeletonLoaderOverlayProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children ?? <MediaInProgressLoader progressPercent={progressPercent} />}
    </Box>
  );
}
